import React from "react";
import { Redirect } from "react-router-dom";
import LogManagement from "../pages/Organization/Dashboard/LogManagement.js";

//Pages
const PagesMaintenance = React.lazy(
  () => import("../pages/Utility/pages-maintenance"),
);
const PagesComingsoon = React.lazy(
  () => import("../pages/Utility/pages-comingsoon"),
);
const Pages404 = React.lazy(() => import("../pages/Utility/pages-404"));
const Pages500 = React.lazy(() => import("../pages/Utility/pages-500"));

// Authentication related pages
const Logout = React.lazy(() => import("../pages/Authentication/Logout"));
const SetPassword = React.lazy(
  () => import("../pages/Authentication/SetPassword"),
);
const ConfirmMail = React.lazy(
  () => import("../pages/AuthenticationInner/page-confirm-mail"),
);
const OrganizationLogin = React.lazy(
  () => import("../pages/Authentication/OrganizationLogin.js"),
);
const OrganizationRegister = React.lazy(
  () => import("../pages/Authentication/OrganizationRegister.js"),
);
const OrganizationForgetPassword = React.lazy(
  () => import("../pages/Authentication/OrganizationForgetPassword"),
);

const TermsAndCondidtions = React.lazy(
  () => import("../pages/Authentication/Terms-and-conditions/index.js"),
);

// Profile
const UpdatePassword = React.lazy(
  () => import("../pages/Profile/UpdatePassword/index"),
);

// Organization
const OrgDashboard = React.lazy(
  () => import("../pages/Organization/Dashboard/index"),
);
const OrgCandidates = React.lazy(
  () => import("../pages/Organization/Candidates/index"),
);
const OrgJobs = React.lazy(() => import("../pages/Organization/Jobs/index"));
const AddCandidate = React.lazy(
  () => import("../pages/Organization/Candidates/add-candidate"),
);
const UpdateCandidate = React.lazy(
  () => import("../pages/Organization/Candidates/update-candidate"),
);
const AddJob = React.lazy(() => import("../pages/Organization/Jobs/add-jobs"));
const BulkImport = React.lazy(
  () => import("../pages/Organization/Candidates/bulk-import"),
);
const BulkImportJob = React.lazy(
  () => import("../pages/Organization/Jobs/bulk-import-job"),
);
const ResetPasswordConfirmMail = React.lazy(
  () => import("../pages/Authentication/reset-password-confirmation"),
);

// view candidate
const ViewCandidate = React.lazy(
  () => import("../pages/Organization/Candidates/viewCandidate"),
);

//my team
const MyTeamList = React.lazy(() => import("../pages/Organization/MyTeam"));
const MyTeamAddNewUser = React.lazy(
  () => import("../pages/Organization/MyTeam/addNewUser"),
);
const UpdateUser = React.lazy(
  () => import("../pages/Organization/MyTeam/updateUser"),
);
const updateJobs = React.lazy(
  () => import("../pages/Organization/Jobs/update-jobs"),
);

// view job
const ViewJob = React.lazy(() => import("../pages/Organization/Jobs/viewJob"));
const Pages403 = React.lazy(() => import("../pages/Utility/pages-403"));

const SubmitFeedBackIndex = React.lazy(() => import("../pages/Feedback/index"));
const OauthCallback = React.lazy(
  () => import("../pages/Organization/OauthCallback/oauthCallback"),
);
const Candidateinterest = React.lazy(
  () => import("../pages/Feedback/Candidateinterest"),
);
const CandidateInterview = React.lazy(
  () => import("../pages/Feedback/CandidateInterview/index"),
);

//Recruiter
const AddOrganization = React.lazy(
  () => import("../pages/Recruiter/addOrganization"),
);
const editOrganization = React.lazy(
  () => import("../pages/Recruiter/editOrganization"),
);
const GetOrganizations = React.lazy(() => import("../pages/Recruiter/index"));

//job
//new
const Clients = React.lazy(() => import("../pages/Recruiter/Clients"));

const viewOrganization = React.lazy(
  () => import("../pages/Recruiter/viewOrganization"),
);
const JobDistrubution = React.lazy(
  () => import("../pages/JtUi/JobDistrubution"),
);

const CareerPage = React.lazy(() => import("../pages/Recruiter/CareerPage"));

const contactus = React.lazy(() => import("../pages/Authentication/contactUs"));
const Feedback = React.lazy(() => import("../pages/Interviewer/Feedback"));
const FeedbackShortlist = React.lazy(
  () => import("../pages/Feedback/shortlist/Feedback"),
);

const Profile = React.lazy(() => import("../pages/Authentication/profile.js"));
const HiringFeedback = React.lazy(() => import("../pages/hiringFeedBack"));
const SubmitFeedBackDocument = React.lazy(
  () => import("../pages/SubmitDocument"),
);
const FeedbackErrorpage = React.lazy(
  () => import("../pages/FeedbackErrorPage"),
);

//template Configuration
const TemplateConfiguration = React.lazy(
  () => import("../pages/Organization/TemplateConfiguration"),
);
const AddTemplate = React.lazy(
  () => import("../pages/Organization/TemplateConfiguration/addTemplate"),
);
const EditTemplate = React.lazy(
  () => import("../pages/Organization/TemplateConfiguration/editTemplate"),
);
const OfferPage = React.lazy(
  () => import("../pages/Feedback/offerLetter/offerPage"),
);
const AiMarkupPage = React.lazy(
  () => import("../pages/Organization/AiMarkupConfiguration"),
);
const AssessmentPage = React.lazy(
  () => import("../pages/Organization/AssessmentPage/AssessmentPage"),
);
const DocumentsPage = React.lazy(
  () => import("../pages/Organization/Documents/documentsPage"),
);
const EditAssessment = React.lazy(
  () =>
    import("../pages/Organization/AssessmentManagement/AssessmentManagementList/EditAssessment"),
);
const AddAssessment = React.lazy(
  () =>
    import("../pages/Organization/AssessmentManagement/AssessmentManagementList/AddAssessment"),
);
const zegocloud = React.lazy(() => import("../pages/zegocloud"));

const ReportIssue = React.lazy(
  () => import("../pages/Organization/Support/reportIssue"),
);
const ReportList = React.lazy(
  () => import("../pages/Organization/Support/reportList"),
);

const Career = React.lazy(() => import("../pages/Authentication/careerPage"));
const AssManagement = React.lazy(
  () => import("../pages/Organization/AssessmentManagement/index"),
);
const CandidateAssessment = React.lazy(
  () => import("../pages/Feedback/CandidateAssessment"),
);

//UnsubscribedEmail
const UnsubscribedEmail = React.lazy(
  () => import("../pages/nonAuthenticatepages/UnsubscribedEmail"),
);
const Migration = React.lazy(() => import("../pages/Organization/Migration"));
const ThirdPartyApp = React.lazy(() => import("../pages/Config/ThirdPartyApp"));
const AppConfiguration = React.lazy(
  () => import("../pages/Configuration/AppConfiguration"),
);

//domain configuration

const DomainConfiguration = React.lazy(
  () => import("../pages/Common/DomainManagement"),
);

//interviewers and shortlist manager

const InterviewersPage = React.lazy(
  () => import("../pages/Organization/Managers/interviewers"),
);
const ShortlistManagersPage = React.lazy(
  () => import("../pages/Organization/Managers/shortlistManagers"),
);

const migrationStatus = React.lazy(
  () => import("../pages/Organization/Migration/migrationStatus"),
);
const Migrations = React.lazy(
  () => import("../pages/Organization/Migration/main"),
);

//hiredecision
const HiredDecision = React.lazy(
  () => import("../pages/Organization/HiredDecision"),
);

//interview page
const InterviewProcesspage = React.lazy(
  () => import("../pages/Organization/InterviewProcess"),
);

//offer letters page
const OfferLetters = React.lazy(
  () => import("../pages/Organization/OfferLetters"),
);
//document verification listing page
const DocumentVerificationDetails = React.lazy(
  () => import("../pages/Organization/DocumentVerificationDetails"),
);
const SwitchUser = React.lazy(() => import("../pages/Common/SwitchUser"));
const ZohoMigration = React.lazy(
  () => import("../pages/Organization/Migration/Migration"),
);
const MigrationProcess = React.lazy(
  () => import("../pages/Organization/Migration/MigrationProcess"),
);
const MigrationLogs = React.lazy(
  () => import("../pages/Organization/Migration/MigrationLogs"),
);
const Recruitment = React.lazy(
  () => import("../pages/Recruitment/Recruitment"),
);
const EmailPages = React.lazy(
  () => import("../pages/Organization/CanddidateEmailTemplate/main"),
);

//recruitment process
const Process = React.lazy(() => import("../pages/process"));

const candidateMaster = React.lazy(
  () => import("../pages/Reports/CandidateMaster"),
);

const JobMaster = React.lazy(() => import("../pages/Reports/JobMaster"));

const Plans = React.lazy(() => import("../pages/Organization/Plans/index"));

const JobPerformance = React.lazy(
  () => import("../pages/Reports/JobPerformance"),
);

const interviewReports = React.lazy(
  () => import("../pages/Reports/interviewReports"),
);

const OrganizationPerformance = React.lazy(
  () => import("../pages/Reports/OrganizationPerformance"),
);
//integration third party for job distributation

const Integration = React.lazy(
  () => import("../pages/Thirdparty_Integration/index"),
);
const ChatPage = React.lazy(() => import("../pages/Chat/ChatPage"));
const AgentManagement = React.lazy(
  () => import("../pages/AgentManagement/index"),
);
const EditAgentPage = React.lazy(
  () => import("../pages/AgentManagement/EditAgentPage"),
);
const CreateAgentPage = React.lazy(
  () => import("../pages/AgentManagement/CreateAgentPage"),
);
const Impersonate = React.lazy(
  () => import("../pages/Authentication/impersonate"),
);
const errorRoutes = [
  { path: "/pages-403", component: Pages403 },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
];

const organizationRoutes = [
  { path: "/report/logs", component: LogManagement },
  { path: "/report/jobperformance", component: JobPerformance },
  { path: "/reports/organization", component: OrganizationPerformance },
  { path: "/report/jobmaster", component: JobMaster },
  { path: "/plans", component: Plans },
  { path: "/report/candidatemaster", component: candidateMaster },
  { path: "/report/interview", component: interviewReports },
  { path: "/recruiter/dashboard", component: OrgDashboard },
  { path: "/dashboard", component: OrgDashboard },
  { path: "/hire/decision", component: HiredDecision },
  { path: "/candidates", component: OrgCandidates },
  { path: "/candidate/add", component: AddCandidate },
  { path: "/candidate/:candidateId/edit", component: UpdateCandidate },
  { path: "/importcandidates", component: BulkImport },
  { path: "/job", component: OrgJobs },
  { path: "/job/open", component: OrgJobs },
  { path: "/job/closed", component: OrgJobs },
  { path: "/job/jd", component: OrgJobs },
  { path: "/job/add", component: AddJob },
  { path: "/job/:jobId/edit", component: updateJobs },
  { path: "/importjob", component: BulkImportJob },
  { path: "/candidate/:candidateId", component: ViewCandidate },

  { path: "/myteam/viewall", component: MyTeamList },
  { path: "/myteam/addnewuser", component: MyTeamAddNewUser },
  { path: "/myteam/updateuser/:userId", component: UpdateUser },
  //{ path: "/viewJob", component: ViewJob },
  { path: "/job/:jobId/process", component: ViewJob },
  { path: "/submitfeedback", component: SubmitFeedBackIndex },

  { path: "/career", component: CareerPage },
  // use new process component
  { path: "/job/:jobId/process/candidate/:candidateId", component: Process },
  { path: "/job/:jobId/process2/candidate/:candidateId", component: Process },

  { path: "/document/verification", component: DocumentVerificationDetails },

  //Template onfiguration
  { path: "/template/config", component: TemplateConfiguration },
  { path: "/template/add", component: AddTemplate },
  { path: "/template/edit", component: EditTemplate },
  { path: "/aimarkup/edit", component: AiMarkupPage },
  { path: "/assessment/edit", component: AssessmentPage },
  { path: "/documents/edit", component: DocumentsPage },
  { path: "/configuration/assessment", component: AssManagement },
  { path: "/configuration/assessment/add", component: AddAssessment },
  { path: `/configuration/assessment/:id/edit`, component: EditAssessment },
  { path: `/configuration/app`, component: ThirdPartyApp },
  { path: `/configuration/appsettings`, component: AppConfiguration },
  { path: "/configuration/shorlistmanagers", component: ShortlistManagersPage },
  { path: "/configuration/interviewers", component: InterviewersPage },

  //Job target URl
  { path: "/jobdistribution", component: JobDistrubution },
  { path: "/callback/zoom", component: OauthCallback },
  { path: "/callback/team", component: OauthCallback },
  { path: "/callback/meet", component: OauthCallback },
  { path: "/callback/linkedin", component: OauthCallback },
  { path: "/feedback/new", component: ReportIssue },
  { path: "/feedback", component: ReportList },
  { path: "/feedback/:id/view", component: ReportList },
  { path: "/careerpage", component: Career },
  { path: "/configuration/assessment/questionBank", component: AssManagement },
  { path: "/configuration/assessment/workflow", component: AssManagement },
  { path: "/migration/job", component: Migration },
  { path: "/migration/candidate", component: Migration },
  { path: "/configuration/domain", component: DomainConfiguration },
  { path: "/migration", component: Migrations },
  { path: "/migration/:type/status/:id", component: migrationStatus },
  { path: "/migration/zoho", component: ZohoMigration },

  { path: "/email/template", component: EmailPages },
  { path: "/email/configuration", component: EmailPages },

  { path: "/interview/process", component: InterviewProcesspage },
  { path: "/offerletter", component: OfferLetters },
  { path: "/switch/:userType", component: SwitchUser },
  { path: "/migration/zoho/process/:type", component: MigrationProcess },
  { path: "/migration/zoho/:type/logs/:id", component: MigrationLogs },
  { path: "/recruitment/:type", component: Recruitment },
  { path: "/integration", component: Integration },
  { path: "/agent-management/create", component: CreateAgentPage },
  {
    path: "/agent-management/edit/:agentType/:agentId",
    component: EditAgentPage,
  },
  { path: "/agent-management", component: AgentManagement },
  //{ path: '/chat', component: ChatPage }, // Now a floating widget, see ChatWidget.jsx
];

const userRoutes = [
  // //profile
  { path: "/profile", component: Profile },
  { path: "/profile/updatepassword", component: UpdatePassword },
  // this route should be at the end of all other routes
  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    // component: () => <Redirect to="/login/organization" />,
    component: () => <Redirect to="/login" />,
  },
];

const authRoutes = [
  { path: "/logout", component: Logout },
  {
    path: "/terms-conditions",
    exact: true,
    component: TermsAndCondidtions,
  },
  // { path: "/index", component: Index },
  {
    path: "/index",
    exact: true,
    // component: () => <Redirect to="/login/organization" />,
    component: () => <Redirect to="/login" />,
  },
  { path: "/contactus", exact: true, component: contactus },
  // { path: "/login/organization", component: OrganizationLogin },
  {
    path: "/login/organization",
    exact: true,
    component: () => <Redirect to="/login" />,
  },
  {
    path: "/login",
    exact: true,
    component: OrganizationLogin,
  },

  // {
  //   path: "/register/organization",
  //   exact: true,
  //   component: OrganizationRegister,
  // },
  {
    path: "/register/organization",
    exact: true,
    component: () => <Redirect to="/register" />,
  },
  { path: "/register", exact: true, component: OrganizationRegister },
  // {
  //   path: "/forgot-password/organization",
  //   exact: true,
  //   component: OrganizationForgetPassword,
  // },
  {
    path: "/forgot-password/organization",
    exact: true,
    component: () => <Redirect to="/forgot-password" />,
  },
  {
    path: "/forgot-password",
    exact: true,
    component: OrganizationForgetPassword,
  },
  // { path: "/register",exact:true, component: Register },
  // { path: "/login", component: () => <Redirect to="/login/organization" /> },

  { path: "/verifyAccount", component: ConfirmMail },
  {
    path: "/verifyResetPassword/organization",
    exact: true,
    component: ResetPasswordConfirmMail,
  },

  {
    path: "/verifyResetPassword/candidate",
    exact: true,
    component: ResetPasswordConfirmMail,
  },
  {
    path: "/verifyResetPassword",
    exact: true,
    component: ResetPasswordConfirmMail,
  },

  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
];
const feedBackRoutes = [
  {
    path: "/feedback/interview/:candidateId",
    exact: true,
    component: Feedback,
  },
  { path: "/feedback/interview", component: CandidateInterview },
  { path: "/shortlist/feedback", component: FeedbackShortlist },
  { path: "/offer/feedback", component: OfferPage },
  { path: "/hire/feedback", component: HiringFeedback },
  { path: "/feedback/error", component: FeedbackErrorpage },
  { path: "/feedback/job/interest", component: Candidateinterest },
  { path: "/feedback/candidate/assessment", component: CandidateAssessment },
  { path: "/submit/document", component: SubmitFeedBackDocument },
  { path: "/webhook/email/unsubscribe", component: UnsubscribedEmail },
  { path: "/meeting", component: zegocloud },
  { path: "/impersonate", component: Impersonate },
  //{ path: '/chat', component: ChatPage },
];
const customRoutes = [
  { path: "/setpassword", component: SetPassword },
  { path: "/resetpassword", component: SetPassword },
];
const oneTimeRoute = [
  { path: "/detail", component: Profile },
  { path: "/recruiter/detail", component: Profile },
];
const recruiterRoute = [
  { path: "/recruiter/dashboard", component: OrgDashboard },
  { path: "/recruiter/addorganization", component: AddOrganization },
  { path: "/recruiter/editorganization", component: editOrganization },
  { path: "/recruiter/viewall", component: GetOrganizations },
  { path: "/recruiter/profile", component: Profile },
  { path: "/dashboard", component: OrgDashboard },
  { path: "/recruiter/organization/view", component: viewOrganization },
  //Job
  { path: "/recruiter/job/add", component: AddJob },
  { path: "/recruiter/job/:jobId/edit", component: updateJobs },

  { path: "/recruiter/job", component: OrgJobs },
  { path: "/recruiter/job/open", component: OrgJobs },
  { path: "/recruiter/job/closed", component: OrgJobs },
  { path: "/recruiter/job/jd", component: OrgJobs },
  { path: "/recruiter/profile/updatepassword", component: UpdatePassword },
  { path: "/career", component: CareerPage },
  { path: "/clients", component: Clients },
];
export {
  authRoutes,
  feedBackRoutes,
  organizationRoutes,
  userRoutes,
  customRoutes,
  oneTimeRoute,
  errorRoutes,
  recruiterRoute,
};
